import { useSearchParams } from 'react-router-dom';

/**
 * Custom hook to check if debug mode is enabled via URL parameter
 * @returns boolean indicating if debug mode is active (?debug=true)
 */
export const useDebugMode = (): boolean => {
  const [searchParams] = useSearchParams();
  return searchParams.get('debug') === 'true';
};